// removed by extract-text-webpack-plugin
module.exports = {"container":"JsX9wXuTBoQzOc1D","apiError":"_2872iaqzNTx7hrc1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/App/App.pcss
// module id = 460
// module chunks = 1